import { useContext, useEffect, useState } from 'react'
import Image from 'react-bootstrap/Image'
import { ThemeContext } from '../../Context/ThemeContext'
import ParticlesJS from './ParticlesJS'
import './styles/Contact.scss'
import './styles/Home.scss'

interface colorShape {
  [key: string]: {
    primary: string
    secondary: string
    fillColor: string
    textColor: string
    bgColor: string
    accentColor: string
    highlight: string
  }
}

const lightColors: colorShape = {
  light: {
    primary: 'rgb(240, 240, 240)',
    secondary: 'rgb(220, 220, 217)',
    fillColor: 'rgb(62, 58, 85)',
    textColor: 'black',
    bgColor: 'rgb(232 237 239)',
    accentColor: 'rgba(22, 26, 55, 0.653)',
    highlight: '#d59c5b',
  },
  dark: {
    primary: 'rgb(60, 64, 95)',
    secondary: 'rgb(48, 45, 61)',
    fillColor: 'white',
    textColor: 'white',
    bgColor: 'rgb(6, 2, 23)',
    accentColor: 'rgba(0, 5, 41, 0.653)',
    highlight: '#d59c5b',
    // highlight: 'violet'
  },
}

interface RepoComponentProps {
  heading: string
  description: string
  url: string
  tags: string
  themeMode: string
  inprogress?: boolean
  disableTile?: boolean
  variation?: string
  featured?: boolean
}
const RepoTile = ({
  heading,
  description,
  url,
  tags,
  themeMode,
  inprogress,
  disableTile,
  variation,
  featured,
}: RepoComponentProps) => {
  return disableTile !== true ? (
    <li className="tile-repo">
      <a href={url} target="_blank" rel="noreferrer">
        <div className="tile-primary-content">
          <div
            className={
              variation === 'important' ? 'title-heading-wrapper title-variation-important' : 'title-heading-wrapper'
            }
            style={{
              zIndex: 99,
              backgroundColor: lightColors[themeMode].accentColor,
            }}>
            <div className="repo-top">
              {/* <p className="repo-heading">Featured Project</p> */}
              {featured ? (
                <p className="repo-heading">Featured Project</p>
              ) : (
                <p className="repo-heading" style={{ height: '23.984px' }}></p>
              )}
              <h2>{heading}</h2>
            </div>
            <div>
              {inprogress ? (
                <p
                  className="title-body-content"
                  style={{
                    color: 'yellow',
                    fontSize: '1.5rem',
                    textTransform: 'uppercase',
                    fontWeight: 600,
                  }}>
                  {description}
                </p>
              ) : (
                <p
                  className="title-body-content"
                  style={{
                    color: 'white',
                    // lightColors[themeMode].textColor
                  }}>
                  {description}
                </p>
              )}
            </div>
            <div className="repo-bottom">
              <p>{tags}</p>
              <div>
                <svg
                  width="22"
                  height="22"
                  fill={`white`}
                  // className="bi bi-github"
                  viewBox="0 0 16 16">
                  <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                </svg>
                <svg width="22" height="22" fill={`white`} viewBox="0 0 16 16">
                  <path
                    fill-rule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="bg-overlay" style={{ backgroundColor: lightColors[themeMode].accentColor }}></div>
          {/* <Image
						src={randomPic}
						alt=""
					/> */}
        </div>
        <div className="tile-secondary-content">
          <div className="content-wrapper">
            <p>Explore</p>
          </div>
        </div>
      </a>
    </li>
  ) : (
    <></>
  )
}
const profilePic = require('../../assets/new_self_image.jpg')

const Home = () => {
  const { currentTheme, setCurrentTheme } = useContext(ThemeContext)

  // const [themeMode, setThemeMode] = useState('dark');
  const [showContact, setShowContact] = useState(false)
  function toggleTheme() {
    setCurrentTheme(currentTheme === 'light' ? 'dark' : 'light')
  }
  function toggleContact() {
    setShowContact(!showContact)
  }

  useEffect(() => {}, [currentTheme])
  const RenderContactScreen = () => {
    return (
      <div className="form-container">
        <div className="form-wrapper">
          <form
            id="contact-form"
            onSubmit={() => {
              setShowContact(!showContact)
              // handleSubmit
            }}
            style={{ background: lightColors[currentTheme].bgColor }}
            method="POST">
            <div className="close-wrapper" onClick={toggleContact}>
              <svg width="25" height="25" fill={`${lightColors[currentTheme].fillColor}`} viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
              </svg>{' '}
            </div>
            <h2 style={{ color: lightColors[currentTheme].textColor }}>CONTACT ME</h2>
            <div className="form-group">
              <label htmlFor="name" style={{ color: lightColors[currentTheme].textColor }}>
                Name
              </label>
              <input type="text" className="form-control" placeholder="Write your name here.." />
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputEmail1" style={{ color: lightColors[currentTheme].textColor }}>
                Email address
              </label>
              <input
                type="email"
                className="form-control"
                aria-describedby="emailHelp"
                placeholder="Let me know how to contact you back.."
              />
            </div>
            <div className="form-group">
              <label htmlFor="message" style={{ color: lightColors[currentTheme].textColor }}>
                Message
              </label>
              <textarea className="form-control" placeholder="What would you like to tell me.."></textarea>
            </div>
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </div>
    )
  }
  const RenderLightIcon = () => {
    return currentTheme === 'light' ? (
      <svg width="60" height="60" fill={`${lightColors[currentTheme].fillColor}`} viewBox="0 0 16 16">
        <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z" />
      </svg>
    ) : (
      <svg width="60" height="60" fill={`${lightColors[currentTheme].fillColor}`} viewBox="0 0 16 16">
        <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z" />
      </svg>
    )
  }

  return (
    <>
      {showContact === true ? <RenderContactScreen /> : <></>}
      <div className="title-grid-wrapper" style={{ backgroundColor: lightColors[currentTheme].bgColor }}>
        <ul className="tile-grid-container">
          <li className="tile-profile" style={{ background: `${lightColors[currentTheme].primary}` }}>
            {/* <a href="#"> */}
            <div className="tile-primary-content">
              <div className="tile-secondary-container">
                <h3 style={{ color: `${lightColors[currentTheme].textColor}` }}>Hi, I'm</h3>
                <h2 style={{ color: lightColors[currentTheme].highlight }}>Spencer Christian</h2>
                <h3 style={{ color: `${lightColors[currentTheme].textColor}` }}>Full-Stack Web Developer</h3>
              </div>
            </div>
            {/* </a> */}
          </li>
          <li className="tile-client">
            <div className="tile-primary-content">
              <Image className="title-profile-image" src={profilePic} alt="" />
            </div>
            <div className="tile-secondary-content"></div>
          </li>
          <li className="tile-bio">
            <div className="tile-primary-content" style={{ background: `${lightColors[currentTheme].primary}` }}>
              <div className="tile-secondary-container">
                <h2 style={{ color: lightColors[currentTheme].highlight }}>BIO</h2>
                <p style={{ color: `${lightColors[currentTheme].textColor}` }}>
                  Driven Web Developer with a passion for using technologies to solve real-world problems. In addition
                  to my excellent attention to detail, I have strong experience in the development and maintenance of
                  complex web-based business applications.
                </p>
              </div>
            </div>
          </li>
          <li className="tile-mini-card-container">
            <a href="https://github.com/schristian4">
              <div className="mini-card" style={{ background: `${lightColors[currentTheme].primary}` }}>
                <h2 style={{ color: `${lightColors[currentTheme].textColor}` }}>Github</h2>
                <svg
                  width="60"
                  height="60"
                  fill={`${lightColors[currentTheme].fillColor}`}
                  // className="bi bi-github"
                  viewBox="0 0 16 16">
                  <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                </svg>
              </div>
            </a>
            <a href="https://www.linkedin.com/in/schristian4/">
              <div className="mini-card" style={{ background: `${lightColors[currentTheme].primary}` }}>
                <h2 style={{ color: `${lightColors[currentTheme].textColor}` }}>Linkedin</h2>
                <svg width="60" height="60" fill={`${lightColors[currentTheme].fillColor}`} viewBox="0 0 16 16">
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                </svg>
              </div>
            </a>
            <a
              href="mailto: spence4dev@gmail.com"
              target="_blank"
              className="mini-card"
              style={{ background: `${lightColors[currentTheme].primary}` }}
              rel="noopener noreferrer">
              <h2 style={{ color: `${lightColors[currentTheme].textColor}` }}>Contact Me</h2>
              <svg width="60" height="60" fill={`${lightColors[currentTheme].fillColor}`} viewBox="0 0 16 16">
                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
              </svg>
            </a>
            <div
              className="mini-card"
              onClick={toggleTheme}
              style={{ background: `${lightColors[currentTheme].primary}` }}>
              <h2 style={{ color: `${lightColors[currentTheme].textColor}` }}>
                {currentTheme === 'light' ? 'Dark' : 'Light'} mode
              </h2>
              <RenderLightIcon />
            </div>
          </li>
          <RepoTile
            heading={'BUDGET EXP'}
            description={`💰BudgetExp App: Track Finances with Ease! 🚀 Say Goodbye to Money Stress! 💸 Astonishing UI & Simplicity to Master Your Money On the Fly! 📱 Don't Miss Out!"`}
            url={'https://budget-exp-home.vercel.app/'}
            tags={'React Native Mobile Design IOS Android'}
            variation={'important'}
            featured={true}
            themeMode={currentTheme}
          />
          <RepoTile
            heading={'Sales Portal'}
            description={`A project created to assist company Sales Team. The sales portal provides analytics and statistical data for a quick in depth understanding of a customer's current status on the platform.`}
            url={'https://sales-dash-eight.vercel.app/'}
            tags={'React TypeScript Node API CSS'}
            featured={true}
            themeMode={currentTheme}
          />
          <RepoTile
            heading={'AlertSite Technical Benchmark'}
            description={`A web app for visualizing AlertSite Remote location statistical data. View categorized major sites, with uptime and error count chart status for each major site.`}
            url={'https://alertsite-bench-app.vercel.app/'}
            tags={'React TypeScript Desktop Components API CSS'}
            featured={true}
            themeMode={currentTheme}
          />
          <RepoTile
            heading={'Multiversus Tier List'}
            description={`Categorize your favorite characters in a detailed Tier list and decide their rank based on their abilities and strengths. You have the power to place your favorite characters where they belong.`}
            url={'https://multiversus-tier-react.vercel.app/'}
            tags={'React HTML CSS'}
            themeMode={currentTheme}
          />
        </ul>
      </div>
      <div>
        {' '}
        <ParticlesJS />
      </div>
    </>
  )
}

export default Home
